import { Directive, ElementRef, Input, AfterContentChecked } from '@angular/core';

@Directive({
  selector: '[wsbAppTextarea]',
  standalone: false
})
export class TextareaDirective implements AfterContentChecked {
  @Input() private minHeight = 100;
  @Input() private autoHeight = true;

  constructor(public element: ElementRef) {}

  ngAfterContentChecked(): void {
    if (this.autoHeight) {
      this.setAutomaticHeight();
    }
  }

  /**
   * Resizes textarea height to fill the content (no scrollbars)
   */
  setAutomaticHeight(): void {
    this.element.nativeElement.style.height = '0px';
    if (this.element.nativeElement.scrollHeight < this.minHeight) {
      this.element.nativeElement.style.height = this.minHeight + 'px';
    } else {
      this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + 5 + 'px';
    }
  }
}
